import { create } from 'zustand';

export interface Toast {
  id: string;
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
}

interface ToastStore {
  toasts: Toast[];
  addToast: (type: Toast['type'], message: string) => void;
  removeToast: (id: string) => void;
}

const DURATION: Record<Toast['type'], number | null> = {
  success: 4000,
  info: 4000,
  warning: 6000,
  error: null, // error toasts require manual dismiss
};

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  addToast: (type, message) => {
    const id = `${Date.now()}_${Math.random()}`;
    set((state) => ({ toasts: [...state.toasts, { id, type, message }] }));
    const duration = DURATION[type];
    if (duration) {
      setTimeout(() => {
        set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
      }, duration);
    }
  },
  removeToast: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));
